exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".item[_v-6e10e5f8]{height:3rem;margin-bottom:.5rem;overflow:hidden;padding:0 .75rem}.item__columns[_v-6e10e5f8]{display:-ms-flexbox;display:flex;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:stretch;align-items:stretch;margin:0 -.75rem}.item__column[_v-6e10e5f8]{padding:0 .75rem;-ms-flex:1 1 0px;flex:1 1 0;width:0}.item__column--shrink[_v-6e10e5f8]{-ms-flex:0 0 0px;flex:0 0 0;width:auto;position:relative;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-6e10e5f8&scoped=true!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/v3-components/Gallery/Item.vue
// module id = 295
// module chunks = 0